module.exports = "//public.zight.com/packs/media/images/icons-search-895706e70a809a6ebea6cf0720a55691.svg";